import { AllVerificationCard } from './AllVerificationCard';

const AccountVerification = () => {
  return (
    <>
      <section>
        <h1 className="font-semibold text-[23px]">Account Verification</h1>
        <hr className="mt-5 mb-7" />
        <AllVerificationCard />
      </section>
    </>
  );
};

export default AccountVerification;
